import { FC, ReactNode } from "react";
import {
  DropdownMenu,
  DropdownMenuButton,
  DropdownMenuContent,
  DropdownMenuItems,
  DropdownMenuTrigger,
} from "~/application/components/DropdownMenu";
import { NavMenuItemType } from "~/application/utils/menu-functions";
import { Text } from "~/components/Text";
import { NavItemLink } from "./NavItemLink";
import { Icon } from "~/components/Icon";
import { Flex } from "~/components/Flex";

export type NavMenuItemProps = {
  isActive?: boolean;
  menuItems?: NavMenuItemType[];
  children: ReactNode;
  menuCustomerItem?: () => void;
  "data-cy"?: string;
  color?: string;
};

export const NavMenuItem: FC<NavMenuItemProps> = ({
  isActive,
  menuItems,
  children,
  menuCustomerItem,
  color,
  "data-cy": dataCy,
}) => {
  const isDropdownTwoColumns = menuItems && menuItems.length > 10;

  let col1Items: NavMenuItemType[] = [];
  let col2Items: NavMenuItemType[] = [];

  if (isDropdownTwoColumns && menuItems) {
    const midIndex = Math.ceil(menuItems.length / 2);
    col1Items = menuItems.slice(0, midIndex);
    col2Items = menuItems.slice(midIndex);
  }

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger data-active={isActive} asChild data-cy={dataCy}>
        <DropdownMenuButton css={{ color }}>{children}</DropdownMenuButton>
      </DropdownMenuTrigger>
      {menuCustomerItem && (
        <DropdownMenuButton onClick={menuCustomerItem}>
          <Text css={{ flexGrow: 1 }}>Dados do cliente</Text>
        </DropdownMenuButton>
      )}
      {menuItems && menuItems?.length > 0 && (
        <DropdownMenuContent align="start">
          {isDropdownTwoColumns ? (
            <Flex css={{ width: "27.5rem" }} data-cy="dropdown-menu-items">
              <DropdownMenuItems css={{ flex: 1 }}>
                {col1Items.map((item) => (
                  <NavItemLink href={item.href} title={item.title} key={item.title}>
                    {item.icon && <Icon as={item.icon} />}
                    <Text css={{ lineHeight: 1 }}>{item.title}</Text>
                  </NavItemLink>
                ))}
              </DropdownMenuItems>
              <DropdownMenuItems css={{ flex: 1 }}>
                {col2Items.map((item) => (
                  <NavItemLink href={item.href} title={item.title} key={item.title}>
                    {item.icon && <Icon as={item.icon} />}
                    <Text css={{ lineHeight: 1 }}>{item.title}</Text>
                  </NavItemLink>
                ))}
              </DropdownMenuItems>
            </Flex>
          ) : (
            <DropdownMenuItems data-cy="dropdown-menu-items">
              {menuItems?.map((item) => (
                <NavItemLink href={item.href} title={item.title} key={item.title}>
                  {item.icon && <Icon as={item.icon} />}
                  <Text css={{ lineHeight: 1 }}>{item.title}</Text>
                </NavItemLink>
              ))}
            </DropdownMenuItems>
          )}
        </DropdownMenuContent>
      )}
    </DropdownMenu>
  );
};
